import { useSyncExternalStore } from "react";

// Whether the user scrolled away while auto-scroll follows playback. Shared between the
// scroll helpers (plain functions) and the "Resume scroll" button.
let paused = false;
const listeners = new Set<() => void>();

export const isAutoScrollPaused = () => paused;

export const setAutoScrollPaused = (value: boolean) => {
  if (paused === value) return;
  paused = value;
  listeners.forEach((listener) => listener());
};

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const useAutoScrollPaused = () => useSyncExternalStore(subscribe, isAutoScrollPaused);
